$(function () {

    //sidenav.js
	// let currentRoute = $('body').data('route-name'),
	// 	// find the element that matches the route
	// 	navBarElm = $('#slide-out').find(`*[data-route-name="${currentRoute}"]`),
	// 	triggerElm = navBarElm.parent().closest('div.collapsible-body').prev(),
	// 	triggerTarget = $('#' + triggerElm.attr('id'));
    //
	// navBarElm.addClass('active');
	// triggerTarget.click().removeClass('active');
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/navigation/sideNavAccordion.js